import { ReadonlyRecord, IDictionary } from '@bimser/core';
import { List, Map, Record } from 'immutable';
import { IDmPanel, DmPanel, DmPanelFactory, DmPanelFactoryFromJS } from '../..';
import { IReadonlyDmPanel } from '../../models/IDmPanel';

export interface IBaseAddPanelPayload {
	panelId: string;
}

export interface IAddPanelPayload extends IBaseAddPanelPayload {
	data: IDmPanel;
}

export interface IReadonlyAddPanelPayload extends IBaseAddPanelPayload {
	data: DmPanel;
}

export type AddPanelPayload = ReadonlyRecord<IReadonlyAddPanelPayload>;

export const AddPanelPayloadFactory = Record<IReadonlyAddPanelPayload>({
	panelId: '',
	data: DmPanelFactory()
});

export const AddPanelPayloadFactoryFromJS = function (data: IAddPanelPayload) {
	return AddPanelPayloadFactory({
		panelId: data.panelId,
		data: DmPanelFactoryFromJS(data.data)
	});
};
